/* eslint-disable react/jsx-no-duplicate-props */
import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
  >
    <path
      d="M3.35371 3.85852L7.62861 2.14856C7.86702 2.05319 8.13298 2.05319 8.37139 2.14856L12.6463 3.85852C12.8599 3.94397 13 4.15087 13 4.38095V6.61484C13 9.86729 11.0198 12.7921 8 14C4.98017 12.7921 3 9.86729 3 6.61484V4.38095C3 4.15087 3.14008 3.94397 3.35371 3.85852Z"
      fill="#FAC600"
    />
    <circle cx="8" cy="8" r="3" fill="#4FC123" />
    <path
      d="M8.95953 6.98239C9.00674 6.93745 9.06956 6.9126 9.13475 6.91309C9.19993 6.91359 9.26237 6.93938 9.3089 6.98504C9.35542 7.03069 9.38239 7.09264 9.38412 7.1578C9.38584 7.22296 9.36218 7.28625 9.31813 7.3343L7.98091 9.00666C7.95791 9.03143 7.93016 9.05131 7.89931 9.0651C7.86846 9.0789 7.83514 9.08633 7.80136 9.08696C7.76757 9.08758 7.734 9.08139 7.70266 9.06874C7.67132 9.0561 7.64285 9.03726 7.61895 9.01337L6.73216 8.12658C6.70747 8.10356 6.68766 8.07581 6.67392 8.04498C6.66018 8.01415 6.6528 7.98086 6.6522 7.94711C6.6516 7.91336 6.65781 7.87984 6.67045 7.84854C6.6831 7.81724 6.70191 7.78881 6.72578 7.76494C6.74965 7.74107 6.77808 7.72226 6.80938 7.70962C6.84068 7.69697 6.8742 7.69077 6.90795 7.69136C6.9417 7.69196 6.97499 7.69934 7.00582 7.71308C7.03665 7.72682 7.0644 7.74663 7.08741 7.77132L7.78921 8.47278L8.95316 6.98977C8.95526 6.98719 8.95749 6.98473 8.95986 6.98239H8.95953Z"
      fill="white"
    />
  </svg>
);

const IconPrivacyPolicy = (props) => <Icon component={icon} {...props} />;

export default IconPrivacyPolicy;
